module.exports = __webpack_public_path__ + "assets/img/store-banner-02.2a118f66.png";